module.exports = __webpack_public_path__ + "img/album12_08.91e4c09c.jpg";